import {
  formatIST,
} from "../utils";

export default function JourneyHistory({
  journey,
}) {
  if (!journey.length) {
    return (
      <div className="py-8 text-center text-xs text-slate-400">
        No activity recorded yet.
      </div>
    );
  }

  return (
    <div>
      {journey.map(
        (item, index) => (
          <div
            key={item.id}
            className="relative flex gap-3 pb-5 last:pb-0"
          >
            <div className="relative flex w-4 shrink-0 justify-center">
              <span className="relative z-10 mt-1 h-2.5 w-2.5 rounded-full bg-slate-900" />

              {index <
                journey.length - 1 && (
                <span className="absolute bottom-0 top-3 w-px bg-slate-200" />
              )}
            </div>

            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap justify-between gap-2">
                <div>
                  <p className="text-xs font-semibold text-slate-800">
                    {item.title}
                  </p>

                  {item.actor && (
                    <p className="mt-0.5 text-[11px] text-slate-400">
                     Assign to {item.actor}
                    </p>
                  )}
                </div>

                <p className="text-[10px] text-slate-400">
                  {Number.isNaN(
                    item.date?.getTime?.()
                  )
                    ? "—"
                    : `${formatIST(
                        item.date
                      )} IST`}
                </p>
              </div>

              {item.notes && (
                <p className="mt-1.5 whitespace-pre-wrap rounded-lg bg-slate-50 px-2.5 py-2 text-xs leading-5 text-slate-600">
                  {item.notes}
                </p>
              )}
            </div>
          </div>
        )
      )}
    </div>
  );
}